import * as React from "react";
import { IBasket } from "../models/IBasket.model";
import DeliveryIcon from "./DeliveryIcon";

function DeliveryBar(props: IBasket) {

	function getDeliveryBarWidthStyle() {
		return {
			width: props.PercentOfFreeDeliveryThreshold + "%"
		};
	}

	function getDeliveryBarIndicatorStyle() {
		return {
			left: props.PercentOfFreeDeliveryThreshold + "%"
		};
	}

	if (props.FreeDeliveryThreshold.Price === 0 || props.SubTotal.Price < props.FreeDeliveryMinimumSpend.Price ) {
		return null;
	}

	return (
		<div className="c-basket__delivery">
			{props.ShippingTotal.Price > 0 ?
				<React.Fragment>
					<div className="c-basket__delivery-title" data-test="free-delivery-additional-spend-message">
						Spend <strong>{props.AdditionalSpendTillFree.Formatted}</strong> more for <strong>free standard delivery</strong>
					</div>
					<div className="c-basket__delivery-bar-container">
					<div className="c-basket__delivery-bar">
						<div className="c-basket__delivery-bar-inner" data-test="free-delivery-threshold-bar" style={getDeliveryBarWidthStyle()}></div>
					</div>
						<div className="c-basket__delivery-indicator" style={getDeliveryBarIndicatorStyle()}>
							<DeliveryIcon />
						</div>
					</div>
				</React.Fragment>
				:
				<div className="c-basket__delivery-title" data-test="free-delivery-message">
					<DeliveryIcon />
					Your basket qualifies for <strong>free delivery</strong>
				</div>
			}
			{!props.HideFreeDeliveryThresholdMessage ?
				<div className="c-basket__delivery-disclaimer" data-test="free-delivery-threshold-disclaimer">(Free standard delivery on orders over {props.FreeDeliveryThreshold.Formatted} to most of UK)</div>
			: null}
		</div>
	);
}

export default DeliveryBar;
